import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filterActions } from './actions';
import { useRequestFilterCommands } from './commandsContext';
import {
  selectFilterCreator,
  selectLastRequestsState,
  selectRequests,
} from './selectors';

const fetchReferenceData = (dispatch, filterCommands, creatorsSource) => {
  dispatch(filterCommands.fetchStages());
  dispatch(filterCommands.fetchAcceptanceStatuses());
  dispatch(filterCommands.fetchWorkers());
  dispatch(filterCommands.fetchExecuters());
  dispatch(filterCommands.fetchCreators(creatorsSource));
  dispatch(filterCommands.fetchServices());
  dispatch(filterCommands.fetchStatuses());
  dispatch(filterCommands.fetchCompanies());
  dispatch(filterCommands.fetchDistricts());
};

export const useFilterInitialization = () => {
  const dispatch = useDispatch();
  const filterCommands = useRequestFilterCommands();
  const lastState = useSelector(selectLastRequestsState);
  const requests = useSelector(selectRequests);
  const filterCreator = useSelector(selectFilterCreator);

  const initialStateRef = useRef({ lastState, requests, filterCreator });
  const previousRequestsRef = useRef(requests);

  useEffect(() => {
    const initialState = initialStateRef.current;

    if (initialState.lastState) {
      dispatch(
        filterActions.retrieveLastState(initialState.lastState.filterState)
      );
    }

    fetchReferenceData(
      dispatch,
      filterCommands,
      {
        requests: initialState.requests,
        filterCreator: initialState.filterCreator,
      }
    );
  }, [dispatch, filterCommands]);

  useEffect(() => {
    if (previousRequestsRef.current === requests) return;

    previousRequestsRef.current = requests;
    dispatch(filterCommands.fetchCreators({ requests, filterCreator }));
  }, [dispatch, filterCommands, filterCreator, requests]);
};
